import axios from "axios";
import { globalErrorHandler } from "../Api";

export const GET_DOMAIN = "GET_DOMAIN";
export const RE_LOADING = "RE_LOADING";

export const getDomains = () => {
  return async (dispatch) => {
    dispatch({
      type: RE_LOADING,
    });

    const apiUrl = "https://middleware.foundever.com/EmployeeToolsAPI";
    // const ApiKey = "7HNRX-D7KGG-3K4RQ-4WPJ4-YTDFH-F013C";

    // const headers = {
    //   ApiKey: `${ApiKey}`,
    //   // Aquí puedes agregar más encabezados si es necesario
    // };

    try {
      const response = await axios.get(`${apiUrl}/authenticate/GetDomains`);

      dispatch({
        type: GET_DOMAIN,
        data: response.data,
      });
    } catch (error) {
      globalErrorHandler(error);
    }
  };
};
